import BaseService from '@/ecm/common/BaseService.js';

class ParameterService {
  baseUrl = 'parameters';

  getAll = () => BaseService.get({ url: `${this.baseUrl}` });
  save = (parameters) => BaseService.post({ url: `${this.baseUrl}/save`, data: parameters });
  clearCache = () => BaseService.post({ url: `${this.baseUrl}/clear-cache` });
  getLog = (filter) => BaseService.post({ url: `${this.baseUrl}/get-log`, data: filter });
  generateSAD = () => BaseService.post({ url: `${this.baseUrl}/generate-sad` });
  getSADExpiration = () => BaseService.get({ url: `${this.baseUrl}/get-sad-expiration` });
  getStringParameter = (key) => BaseService.get({ url: `${this.baseUrl}/string/${key}` });
}

export default new ParameterService();
